import { Duration } from "luxon";
import { DayHourMinutePicker } from "../day_hour_minute_picker";
import { Disabler } from "../disabler";
import { useEventCreationContext } from "../hooks/use_event_creation_context";
import { SeshAccordianComponent } from "../sesh_accordian_component";

export function LockRSVPsBefore(props: { disabled?: boolean }) {
	const event_state = useEventCreationContext();

	const start_time = event_state.state.start_time;

	const duration = Duration.fromMillis(
		event_state.state.rsvp_lock_before_ms ?? 0
	);

	let description: JSX.Element | undefined;
	if (start_time) {
		description = (
			<span>
				RSVPs will be locked on{" "}
				<span className="font-semibold">
					{start_time.toLocal().minus(duration).toLocaleString({
						dateStyle: "full",
						timeStyle: "short",
					})}
				</span>
			</span>
		);
	} else {
		description = (
			<span>
				RSVPs will be locked{" "}
				<span className="font-semibold">
					{duration.toFormat("d 'days,' h 'hours,' m 'minutes'")}
				</span>{" "}
				before event start
			</span>
		);
	}

	return (
		<SeshAccordianComponent
			disabled={props.disabled}
			does_require_premium={true}
			does_server_have_premium={event_state.props.is_premium}
			info={
				"Prevent users from RSVPing a certain amount of time before the event starts."
			}
			is_opened={event_state.state.rsvp_lock_before_ms !== null}
			label="Close RSVPs Early"
			onChange={(isOpen) => {
				event_state.setState({
					rsvp_lock_before_ms: !isOpen ? null : 1000 * 60 * 60,
				});
			}}
			is_new
			closed_element={
				<Disabler disabled={true}>
					<div className="flex flex-col gap-2">
						<p>RSVPs will not be locked before event start.</p>
						<DayHourMinutePicker
							duration_ms={1000 * 60 * 60}
							updateFunc={() => {}}
						/>
					</div>
				</Disabler>
			}
		>
			<Disabler disabled={props.disabled}>
				<div className="flex flex-col gap-2">
					<div>{description}</div>
					<DayHourMinutePicker
						duration_ms={event_state.state.rsvp_lock_before_ms ?? 0}
						updateFunc={(val) =>
							event_state.setState({
								rsvp_lock_before_ms: val,
							})
						}
					/>
				</div>
			</Disabler>
		</SeshAccordianComponent>
	);
}
